import React from 'react';
import { Drawer, FormDistributor } from '../../components';
import { useStyles } from '../../services/material-ui';

const EditCompany: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <FormDistributor />
      </main>
    </div>
  );
};

export default EditCompany;
